const captionCls = "_b7nc2bxu2a";
const contentCls = "_b7nc1kgzzd4";
const spanCls = "_b7ns339emr";

export { captionCls, contentCls, spanCls };
import "./atom.caption.style.linaria.module.css";
//# sourceMappingURL=atom.caption.style.js.map
